import { render, staticRenderFns } from "./TimeData.vue?vue&type=template&id=58030f68"
import script from "./TimeData.vue?vue&type=script&lang=js"
export * from "./TimeData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports